import React from 'react';
import { Handle, Position } from 'reactflow';
import { FaBolt } from 'react-icons/fa';

const TriggerNode = ({ data, isConnectable }) => {
  const isConfigured = data.config && Object.keys(data.config).length > 0;

  return (
    <div className={`custom-node trigger-node ${!isConfigured ? 'unconfigured' : ''}`}>
      <div className="node-icon">
        <FaBolt />
      </div>
      <div className="node-content">
        <div className="node-label">{data.label}</div>
        {!isConfigured && <div className="node-status">Not configured</div>}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="node-handle"
      />
    </div>
  );
};

export default TriggerNode;

